import type { TileBox } from "../multiview-layout";
import type { CropRect, SceneMaster } from "./types";

interface SceneCropProps {
  /** Active scene master (URL + native pixel dimensions). */
  master: SceneMaster;
  crop: CropRect;
  targetBox: TileBox;
  opacity?: number;
  clipPathId?: string;
  transform?: string;
  title?: string;
  desc?: string;
}

export default function SceneCrop({
  master,
  crop,
  targetBox,
  opacity = 1,
  clipPathId,
  transform,
  title,
  desc,
}: SceneCropProps) {
  const { url, width, height } = master;
  return (
    <svg
      x={targetBox.x}
      y={targetBox.y}
      width={targetBox.width}
      height={targetBox.height}
      viewBox={`${crop.x * width} ${crop.y * height} ${crop.width * width} ${crop.height * height}`}
      preserveAspectRatio="xMidYMid slice"
      opacity={opacity}
      transform={transform}
      {...(clipPathId ? { clipPath: `url(#${clipPathId})` } : {})}
    >
      {title && <title>{title}</title>}
      {desc && <desc>{desc}</desc>}
      <image href={url} x={0} y={0} width={width} height={height} />
    </svg>
  );
}
